export const camelToSnakeCase = (str) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

export const snakeToCamelCase = (key) =>
  key.replace(/_(\w)/g, (_, char) => char.toUpperCase())
